<template>
  <li
    id="self-con-certificate"
    v-if="form.certificateOrderProduct.includes('changeOfNameCertificate')"
  >
    <span class="h3">Your change of name details</span>
    <ol class="questions">
      <li>
        <fieldset>
          <span class="label"><strong>New name</strong></span>
          <ol class="questions">
            <li>
              <InputWithError 
                v-model="form.newGivenName"
                id="newGivenName"
                name="New Given Name"
                label="First name"
                maxlength="60"
                size="35"
              />
            </li>
            <li>
              <label for="newMiddleNames">
                <span class="label">Middle name(s)</span></label
              >
              <input
                id="newMiddleNames"
                autocomplete="additional-name"
                v-model="form.newMiddleNames"
                name="New Middle Name(s)"
                type="text"
                class="stretchWidth"
                maxlength="255"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.newFamilyName"
                id="newFamilyName"
                name="New Family Name"
                label="Family name"
                maxlength="60"
                size="30"
                hint="If your new name doesn't include a family name and you only use
                the name above, enter n/a."
              />
            </li>
          </ol>
        </fieldset>
        <fieldset>
          <span class="label"><strong>Name at birth</strong></span>
          <ol class="questions">
            <li>
              <InputWithError 
                v-model="form.birthGivenName"
                id="birthGivenName"
                name="Birth Given Name"
                label="First name"
                maxlength="60"
                size="35"
              />
            </li>
            <li>
              <label for="birthMiddleNames">
                <span class="label">Middle name(s)</span></label
              >
              <input
                id="birthMiddleNames"
                autocomplete="additional-name"
                v-model="form.birthMiddleNames"
                name="Birth Middle Name(s)"
                type="text"
                class="stretchWidth"
                maxlength="255"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.birthFamilyName"
                id="birthFamilyName"
                name="Birth Family Name"
                label="Family name"
                maxlength="60"
                size="35"
                hint="If your birth name doesn't include a family name and you only
                use the name above, enter n/a."
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.dateOfBirthSelf"
                id="dateOfBirthSelf"
                name="Date of birth"
                label="Date of birth"
                maxlength="60"
                size="35"
                hint="dd/mm/yyy"
                :max="today"
                type="date"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.birthTownCitySelf"
                id="birthTownCitySelf"
                name="Birth Town"
                label="Town or city"
                maxlength="60"
                size="15"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.birthStateSelf"
                id="birthStateSelf"
                name="Birth State"
                label="State or territory"
                maxlength="70"
                size="15"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.dateOfNameChangeSelf"
                id="dateOfNameChangeSelf"
                name="Date of name change"
                label="Date of name change"
                maxlength="10"
                size="10"
                type="date"
                :max="today"
              />
            </li>
          </ol>
        </fieldset>
      </li>
    </ol>
  </li>
</template>

<script>
import InputWithError from '../../InputWithError.vue';

export default {
  components: {
    InputWithError,
  },
  props: {
    value: Object,
    today: String,
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
